import * as Immutable from 'immutable';
import {
  GET_DASHBOARD_ASSETALLOCATION_ABORTED,
  GET_DASHBOARD_ASSETALLOCATION_REQUESTED,
  GET_DASHBOARD_ASSETALLOCATION_COMPLETED,
  GET_DASHBOARD_ASSETALLOCATION_FAILED,
  RESET_DASHBOARD_ASSETALLOCATION_REQUESTED,
  RESET_DASHBOARD_ASSETALLOCATION_COMPLETED,
} from '../../actions/dashboardassetallocations/types';

const schema = {
  // status: 'INIT', // INIT/OK/ERROR
  error: null,
  data: null,
  resettingdata: false,
  gettingdata: false,
  gotdata: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DASHBOARD_ASSETALLOCATION_ABORTED:
      return state.set('error', null).set('gettingdata', false);

    case GET_DASHBOARD_ASSETALLOCATION_REQUESTED:
      return state.set('error', null).set('gettingdata', true);

    case GET_DASHBOARD_ASSETALLOCATION_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('data', action.payload);

    case GET_DASHBOARD_ASSETALLOCATION_FAILED:
      return state.set('error', action.payload);

    case RESET_DASHBOARD_ASSETALLOCATION_REQUESTED:
      return state.set('error', null).set('resettingdata', true);

    case RESET_DASHBOARD_ASSETALLOCATION_COMPLETED:
      return state
        .set('error', null)
        .set('resettingdata', false)
        .set('data', null);
    default:
      return state;
  }
};

export { initialState };

export default reducer;
